// extracted by mini-css-extract-plugin
export default {"alert_success":"AlertSuccess_alert_success__nWiB4"};